import { ADMIN_STATE_KEY } from "~/admin";
import { EQUIPMENT_SETUP_DATA_KEY } from "./reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][EQUIPMENT_SETUP_DATA_KEY];

export const getAgBytesEquipmentData = (state) => _getModuleState(state).agBytesEquipmentData;
